<template>
  <v-card class="text-center">
    <div class="loading_content">
      <v-img
        :src="loadingIcon"
        :lazy-src="loadingIcon"
        class="loading_icon mx-auto"
      ></v-img>
      <!-- <v-img :src="loadingIcon" class="loading_icon mx-auto"></v-img> -->
      <span class="quote_text">{{ selectedQuote }}</span>
    </div>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      loadingIcon: require("@/assets/loadingIcon.svg"),
      quotes: [
        "Risk-to-Reward Ratio is a measure of the potential loss versus the potential profit of a trade.",
        "Maintain trading discipline by exiting trades at predefined target prices or stop loss levels.",
        "Trailing Stop Loss adjusts your stop price as the market price moves in your favor, protecting gains and limiting losses.",
        "Holding Period is the duration an investment is kept before being sold.",
        "Upcoming Trade is a potential opportunity to trade when the market price reaches the suggested entry price.",
        "Live Trade showcases the performance of a suggested trade in the live market.",
        "Profit Potential is the expected profit that can be realized by taking the suggested trade.",
        "Take the recommended trade by clicking on the TRADE button on the trade card.",
        "SEBI Registered Experts give exclusive trade recommendations in Premium Groups.",
        "Average Trade Return is the average of returns generated from all Closed Trades.",
        "ROI is a measure of investment profitability, calculated as a percentage of the initial investment cost.",
      ],
      selectedQuote: "",
      quoteIndex: 0,
      intervalId: null,
    };
  },
  created() {
    this.startQuoteRotation();
  },
  beforeDestroy() {
    clearInterval(this.intervalId); // Clean up the interval when the component is destroyed
  },
  methods: {
    startQuoteRotation() {
      this.selectRandomQuote();
      this.intervalId = setInterval(() => {
        this.selectRandomQuote();
      }, 3000); // Change quote every 3 seconds
    },
    selectRandomQuote() {
      const randomIndex = Math.floor(Math.random() * this.quotes.length);
      this.selectedQuote = this.quotes[randomIndex];
    },
  },
};
</script>

<style scoped>
.fullscreen {
  min-width: 100vw !important;
  min-height: 100vh !important;
  margin: 0 !important;
}
.loading_icon {
  height: 100px;
  width: 100px;
}
.loading_content {
  padding-top: 15%;
}
@media (max-width: 600px) {
  .loading_content {
    padding: 60% 5% 0% 5%;
  }
}
</style>
